import { makeCygnusApiCall } from "../../../../../api/api";
import { ApproverData } from "./ApprovalStatusRenderer.utils";

/**
 * Fetches approvers data for a given client to display in the approval status popup.
 * 
 * @param clientMasterId - The ID of the client whose approvers data is being requested.
 * @param setApproversData - Setter function to update the approvers data in state.
 * @param setApprovalStatusRefreshGrid - Setter function to control loading state for the grid.
 */
export const fetchApprovalPageData = async (
  clientMasterId: number,
  setApproversData: (value: ApproverData[]) => void,
  setApprovalStatusRefreshGrid: (value: boolean) => void
) => {
  setApprovalStatusRefreshGrid(true);

  const response = await makeCygnusApiCall({
    type: "GET",
    payload: {}, 
    url: `/form/clientapprovers/?ClientMasterId=${clientMasterId}&SendForApproval=Y`,
    show_message: true,
    customized_success_message: "Fetched approvers data.",
    customized_failure_message:
      "Unable to fetch approvers, please try again. If the problem persists, contact support with a screenshot.",
    customized_error_message:
      "Error occurred while fetching approvers, please contact support and attach a screenshot.",
    isblob: false,
    forMDM: true
  });

  if (response.success) {
    setApproversData(response.data);
  }

  setApprovalStatusRefreshGrid(false);
};
